module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('link', {
    attrs: {
      "href": "styles/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("Aunt Bee’s Delightful Desserts: More Than 350 Recipes from Mayberry, Americas’s Friendliest Town")]), _vm._v(" "), _c('p', {
    staticClass: "ctr",
    attrs: {
      "id": "pz21-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#RR_19",
      "id": "CC_19"
    }
  }, [_vm._v(" Howard’s Bachelor Pad Punch")])]), _vm._v(" "), _c('p', {
    staticClass: "tx6",
    attrs: {
      "id": "pz21-2"
    }
  }, [_c('i', [_vm._v(" Bubbly, boys. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pACX"
    }
  }, [_c('b', [_vm._v(" 1 packet cherry Kool-Aid ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pA9cC"
    }
  }, [_c('b', [_vm._v(" 1 packet strawberry Kool-Aid ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pAr0V"
    }
  }, [_c('b', [_vm._v(" 2 cups sugar ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pAs5s"
    }
  }, [_c('b', [_vm._v(" 2 quarts cold water ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pAn3L"
    }
  }, [_c('b', [_vm._v(" 1 6-ounce can frozen orange juice ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "AdjH"
    }
  }, [_c('b', [_vm._v(" 1 6-ounce can frozen lemonade ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "AnTg"
    }
  }, [_c('b', [_vm._v(" 1 quart ginger ale ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "pAurq"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("D")]), _vm._v("issolve Kool-Aid and sugar in water. Add juices. Pour into punch bowl and slowly add ginger ale.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pAJk"
    }
  }, [_vm._v(" Makes 1 gallon.")]), _vm._v(" "), _c('p', {
    staticClass: "txrr",
    attrs: {
      "id": "pAkmX"
    }
  }, [_c('i', [_vm._v("Janine Johnson—Orlando, Florida")])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    attrs: {
      "id": "AGR"
    }
  }, [_c('p', {
    staticClass: "tx1a",
    attrs: {
      "id": "pAix"
    }
  }, [_c('i', [_vm._v("Great shakes at Opie’s new soda fountain job:")])]), _vm._v(" "), _c('table', {
    attrs: {
      "id": "pAZM"
    }
  }, [_c('tbody', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "id": "AZM"
    }
  }, [_c('tr', {
    attrs: {
      "id": "tr-AZM-0"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-AZM-0-0"
    }
  }, [_vm._v("HOWARD")]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-AZM-0-1"
    }
  }, [_vm._v("(to Andy): He’s a pro at that counter, all right. I especially like the way he makes the malteds. You know, he gets the ice cream mixed in thoroughly.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-AZM-1"
    }
  }, [_c('td', {
    attrs: {
      "colspan": "2",
      "id": "td-AZM-1-0"
    }
  }, [_c('i', [_vm._v("Later")]), _vm._v(":")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-AZM-2"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-AZM-2-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("HOWARD:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-AZM-2-1"
    }
  }, [_vm._v("Hey, Ope. That malted you made for me at lunch—par excellence.")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "image",
    attrs: {
      "id": "pAA7N"
    }
  }, [_c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "images/img-21-1.jpg",
      "id": "AA7N",
      "src": "images/img-21-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "txcc",
    attrs: {
      "id": "pABIj"
    }
  }, [_c('i', [_vm._v("Without his bow tie, Howard could be Mayberry’s swingingest bachelor.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b333cdc2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter19.vue
// module id = 120
// module chunks = 0